import '../../styles/sections/product-main.scss';
import '../../styles/components/price.scss';

import { updateRecentlyViewed } from '../utils/cart';

const productHandle = document.querySelector('[data-product-main-handle]')?.dataset.productMainHandle;

updateRecentlyViewed(productHandle);
